import React from 'react';
// import resalatAbout from '../../ass/resalat-about.png'
import resalat0 from '../../ass/resalat0.jpg'
import { TypeAnimation } from 'react-type-animation';
import Fade from 'react-reveal/Fade';

const About = () => {
    return (
        <section id='about' className='my-20'>
            <Fade bottom cascade>
            <div className="max-w-5xl lg:mx-auto mx-5 flex lg:justify-around flex-col lg:flex-row gap-8 items-center mt-16">
                    <div className='relative'>
                        {/* <div className="bg-black  absolute w-80 h-[400px] opacity-50"></div> */}
                        <img className='rounded-xl  h-[400px]' src={resalat0} alt="" />
                    </div>
                    <div className='mx-10 lg:mx-0'>  
                        <h1 className='lg:text-5xl text-3xl font-bold'> About  <span className='text-red-500'>Me</span></h1>
                        <div className='flex items-center lg:text-3xl text-2xl w-full text-white mt-2'>
                                <p className='mr-3 text-gray-300'>Creative</p>
                            <TypeAnimation
                            sequence={[
                                'web devloper',
                                2000,
                                'Front end developer', 
                                2000, 
                                'Backend developer', 
                                2000,
                                ' ',
                                () => {
                                    
                                }
                            ]}
                            
                            wrapper="div"
                            cursor={true}
                            repeat={Infinity}
                            />
                        </div>
                        <hr className='my-5 border-dotted'/>
                        <div className='lg:w-96 w-80'>
                        <p>My name is Resalat Islam. I am a Mern stack developer and am very passionate and dedicated to my work. With 1 year of experience as a professional a Mern stack, I have acquired the skills and knowledge.</p>
                        </div>
                    </div>
            </div>
                </Fade>
        </section>
    );
};

export default About;